import AdminModal from "../../../components/AdminModal";

const ErrorModal = ({ show, onClose, errorText }) => {
  return (
    <AdminModal
      show={show}
      size="modal-md"
      centered={true}
      onClose={onClose}
      title={"ERROR"}
    >
      <h5 className="text-center text-EB001B">{errorText}</h5>
    </AdminModal>
  );
};

export default ErrorModal;
